// extracted by mini-css-extract-plugin
export default {"root":"ReactionPickerLimited-module__root","wrapper":"ReactionPickerLimited-module__wrapper"};